import React from 'react';
import { FieldTitle } from '../common/index';
import DefaultValue from './defaultValue';

function RadioButton(props) {
  const { label, internalTitle, options, formId, required, className } = props;
  const asterisk = required && label.length ? ' *' : null;
  const usedLabel = label.length ? (
    <label className="generic">
      {label}
      {asterisk}
    </label>
  ) : null;
  const contentArticleFormId = `content_article_form-${props.contentArticleFormId}`;
  const possibleValues = options.for_radio.map((item, index) => {
    const forId = `${contentArticleFormId}-${FieldTitle.titleFor(internalTitle, formId, index)}`;

    return (
      <div key={`radio-${internalTitle}-${index}`}>
        <input
          type="radio"
          value={item.value}
          name={internalTitle}
          id={forId}
          required={required}
          defaultChecked={DefaultValue.radioAutomatically(options, item.value)}
        />
        <label htmlFor={forId}>
          <span className="diamond-outer">
            <span className="diamond-inner" />
          </span>
          {item.title}
        </label>
      </div>
    );
  });

  return (
    <div className={`${className} input radio`}>
      {usedLabel}
      {possibleValues}
    </div>
  );
}

RadioButton.propTypes = {
  label: React.PropTypes.string,
  internalTitle: React.PropTypes.string,
  options: React.PropTypes.object,
  formId: React.PropTypes.number,
  contentArticleFormId: React.PropTypes.number,
  required: React.PropTypes.bool,
  className: React.PropTypes.string
};

RadioButton.defaultProps = {
  className: 'formgroup'
};

export default RadioButton;



// WEBPACK FOOTER //
// ./components/forms/radioButton.js